import { alpha, createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const styles = ({ palette, spacing }: Theme) =>
  createStyles({
    root: {
      alignItems: 'center',
      borderRadius: 6,
      color: colors.white.lightest,
      display: 'flex',
      flexWrap: 'nowrap',
      fontSize: 14,
      height: 40,
      justifyContent: 'space-between',
      margin: 0,
      outline: `1px solid ${alpha(colors.white.lightest, 0.2)}`,
      padding: spacing(2.5, 2),
      transition: 'color 0.4s ease',

      '&:hover': {
        backgroundColor: alpha(colors.white.lightest, 0.15),
        color: colors.white.lightest,
        cursor: 'pointer',
        outline: 'none',
      },
    },
    badge: {
      borderRadius: 4,
      flex: '0 0 auto',
      padding: spacing(1, 1.5),
      fontSize: 10,
    },
    title: {
      display: 'inline-block',
      fontSize: 12,
      fontWeight: 700,
      overflow: 'hidden',
      position: 'relative',
      textOverflow: 'clip',
    },
    icon: {
      blockSize: 'calc(100% + 1px)',
      fontSize: 12,
    },
  });
